import { DELETE_USER, GET_STAFF_BY_LOCATION } from "../services/apiUrls";
import { Delete, get } from "../services/service";

export const fetchActiveEmployees = async (tenantId, locationId) => {
  let response = await get(
    GET_STAFF_BY_LOCATION.replace("{tenantId}", tenantId).replace("{locationId}", locationId)
  );
  return response.length>0 ? response.map((emp) => ({...emp.user,label:emp.user.firstName, name:emp.user.firstName})) : [];
};

export const deleteUser = async (userId) => {
  try {
    let resposne = await Delete(DELETE_USER.replace("{userId}", userId));
    return resposne;
  } catch (error) {
    return error;
  }
};
